import React, { useState, useEffect } from 'react';
import { 
  Wifi, 
  Bluetooth, 
  Sun, 
  Volume2, 
  ArrowUp, 
  Info, 
  MapPin, 
  Plane, 
  RotateCcw, 
  X,
  Bell,
  Camera,
  Flashlight,
  Calculator,
  ArrowRight
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const ModernControlCenter = () => {
  const [wifiEnabled, setWifiEnabled] = useState(true);
  const [bluetoothEnabled, setBluetoothEnabled] = useState(true);
  const [brightness, setBrightness] = useState(75);
  const [volume, setVolume] = useState(60);
  const [airplaneMode, setAirplaneMode] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  // Show notification after component mounts
  useEffect(() => {
    const timer = setTimeout(() => setShowNotification(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const ControlToggle = ({ icon: Icon, label, enabled, onToggle, color = "blue" }) => (
    <div className="bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-md border border-white/20">
      <button 
        onClick={onToggle}
        className={`w-full flex items-center justify-between transition-all duration-300 ${
          enabled ? 'opacity-100' : 'opacity-60'
        }`}
      >
        <div className="flex items-center space-x-2">
          <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${
            enabled 
              ? `bg-${color}-500 text-white shadow-md shadow-${color}-200` 
              : 'bg-gray-200 text-gray-400'
          }`}>
            <Icon className="w-3 h-3" />
          </div>
          <span className={`text-xs font-medium transition-colors duration-300  ${
            enabled ? 'text-gray-900' : 'text-gray-500'
          }`}>
            {label}
          </span>
        </div>
        <div className={`w-8 h-4 rounded-full transition-all duration-300 ${
          enabled ? `bg-${color}-500` : 'bg-gray-300'
        } relative`}>
          <div className={`w-3 h-3 bg-white rounded-full shadow-sm transition-all duration-300 absolute top-0.5 ${
            enabled ? 'translate-x-4' : 'translate-x-0.5'
          }`} />
        </div>
      </button>
    </div>
  );

  const SliderControl = ({ icon: Icon, label, value, onChange, color = "blue" }) => (
    <div className="bg-white/90 backdrop-blur-sm rounded-xl p-3 shadow-md border border-white/20">
      <div className="flex items-center space-x-2 mb-2">
        <div className={`w-6 h-6 rounded-full bg-${color}-500 flex items-center justify-center text-white shadow-md shadow-${color}-200`}>
          <Icon className="w-3 h-3" />
        </div>
        <span className="text-xs font-medium text-gray-900">{label}</span>
      </div>
      <div className="relative">
        <input
          type="range"
          min="0"
          max="100"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          className={`w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer slider-${color}`}
        />
        <div className={`absolute right-1 top-2 text-xs font-medium text-${color}-600`}>
          {value}%
        </div>
      </div>
    </div>
  );

  const QuickAction = ({ icon: Icon, label, color = "gray" }) => (
    <button className="bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-md border border-white/20 flex flex-col items-center justify-center space-y-1 hover:scale-105 transition-all duration-300 hover:shadow-lg">
      <div className={`w-6 h-6 rounded-full bg-${color}-500 flex items-center justify-center text-white shadow-md shadow-${color}-200`}>
        <Icon className="w-3 h-3" />
      </div>
      {/* <span className="text-xs font-medium text-gray-700">{label}</span> */}
    </button>
  );

//   const PushNotification = () => (
//     <div className={`fixed top-4 left-4 right-4 z-50 transform transition-all duration-700 ${
//       showNotification ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
//     }`}>
//       <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 mx-auto max-w-sm">
//         <div className="flex items-start space-x-3">
//           <div className="flex-shrink-0">
//             <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
//               <Bell className="w-4 h-4 text-white" />
//             </div>
//           </div>
//           <div className="flex-1 min-w-0">
//             <div className="flex items-center justify-between mb-1">
//               <p className="text-sm font-semibold text-gray-900">Staccato</p>
//               <p className="text-xs text-gray-500">now</p>
//             </div>
//             <p className="text-sm text-gray-800 font-medium mb-1">Your Last Chance to Shop</p>
//             <p className="text-xs text-gray-600">Visit Staccato stores nearest you now.</p>
//           </div>
//           <button 
//             onClick={() => setShowNotification(false)}
//             className="flex-shrink-0 text-gray-400 hover:text-gray-600"
//           >
//             <X className="w-4 h-4" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );

  const AdBanner = () => (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
      <div className="relative">
        {/* Ad Label */}
        {/* <div className="absolute top-3 left-3 bg-black/80 text-white px-2 py-1 rounded text-xs font-medium z-10">
          AD
        </div> */}
        
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
  <img
    src="/assets/fitfloppush.png"
    alt="Fashion model in stylish outfit"
    className="w-full h-full object-cover"
  />
</div>
        
      
        
      </div>
    </div>
  );

  return (
    <>

      <Helmet>
       <title>
        FitFlop Campaign | Push Notification Ad Showcase by Bidbox
        </title>
        <meta
          name="description"
          content="Discover how FitFlop uses Push Notification ads with Bidbox. Explore engaging campaigns that drive instant action & boost customer connection."
        />
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/push-notification/fitflop"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 mt-16">
      {/* Push Notification */}
      {/* <PushNotification /> */}

      <div className="container mx-auto px-4 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-10">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Step Into Action
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Push Notification
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                REACH THEM IN REAL TIME
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                Push Notifications put Fitflop at your audience’s fingertips—alerting them to fresh collections, limited-time offers, or back-in-stock favorites the moment they happen. Your message pops up instantly, inspiring quick clicks and faster conversions. It’s timely, targeted, and designed to get feet moving.                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                                 <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                                   <span>Start with this Template</span>
                                   <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                                 </button>
                                 </Link>
              </div>
            </div>
          </div>

          {/* Right column - iPhone Mockup */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              {/* iPhone mockup */}
              <div className="mx-auto max-w-xs relative">
                {/* iPhone Frame */}
                <div className="bg-black rounded-[2.5rem] p-2 shadow-2xl">
                  <div className="bg-whie rounded-[2rem] overflow-hidden relative">
                    
                    {/* Status Bar */}
                    <div className="bg-white px-4 py-2 flex justify-between items-center text-black text-sm font-medium">
                      <span>9:41</span>
                      <div className="flex items-center space-x-1">
                        <div className="flex space-x-1">
                          <div className="w-1 h-2 bg-black rounded-full"></div>
                          <div className="w-1 h-2 bg-black rounded-full"></div>
                          <div className="w-1 h-2 bg-black rounded-full"></div>
                          <div className="w-1 h-2 bg-black rounded-full"></div>
                        </div>
                        <div className="w-6 h-3 border border-black rounded-sm relative ml-1">
                          <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                        </div>
                      </div>
                    </div>

                    {/* Control Center Content */}
                    <div className="p-3 bg-gray-50 h-[500px] overflow-hidden">
                      
                      {/* Main Controls Grid */}
                      <div className="grid grid-cols-2 gap-2 mb-4">
                        <ControlToggle
                          icon={Wifi}
                          label="Wi-Fi"
                          enabled={wifiEnabled}
                          onToggle={() => setWifiEnabled(!wifiEnabled)}
                          color="blue"
                        />
                        <ControlToggle
                          icon={Bluetooth}
                          label="Bluetooth"
                          enabled={bluetoothEnabled}
                          onToggle={() => setBluetoothEnabled(!bluetoothEnabled)}
                          color="blue"
                        />
                      </div>

                   

                      {/* Quick Actions Grid */}
                      <div className="grid grid-cols-4 gap-2 mb-4">
                        <QuickAction icon={ArrowUp} label="AirDrop" color="blue" />
                        <QuickAction icon={Info} label="Info" color="gray" />
                        <QuickAction icon={MapPin} label="Location" color="red" />
                        <QuickAction 
                          icon={Plane} 
                          label="Airplane" 
                          color={airplaneMode ? "orange" : "gray"}
                        />
                      </div>

                      {/* Ad Banner */}
                      <AdBanner />
                    </div>

                    {/* Bottom Indicator */}
                    <div className="h-1 bg-black rounded-full w-24 mx-auto mb-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .slider-blue::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #3b82f6;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(59, 130, 246, 0.3);
        }
        
        .slider-yellow::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #eab308;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(234, 179, 8, 0.3);
        }
        
        .slider-green::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #22c55e;
          cursor: pointer;
          box-shadow: 0 2px 6px rgba(34, 197, 94, 0.3);
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>


       <div className="max-w-7xl mx-auto px-4 py-10">
                    <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
              
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                      {/* Card 1 */}
                      <Link to="/ctv-carousel-l-band/lenovo" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/Lenovo.avif"
                          alt="Card 1"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Lenovo</h2>
                        </div>
                      </Link>
              
                      {/* Card 2 */}
                      <Link to="/dynamic-calculator/zakat" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/zakat.webp"
                          alt="Card 2"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Zakat Calculator</h2>
                        </div>
                      </Link>
              
                      {/* Card 3 */}
                      <Link to="/interactive-selector/donation" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/donation.png "
                          alt="Card 3"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Donation</h2>
                        </div>
                      </Link>
              
                      {/* Card 4 */}
                      <Link to="/spin-the-wheel/mamaearth" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/mam1.jpg"
                          alt="Card 4"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Mama Earth</h2>
                        </div>
                      </Link>
              
                     
                    </div>
                  </div>
    </>
  );
};

export default ModernControlCenter;

// import React, { useState, useEffect } from 'react';
// import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe, ChevronLeft, ChevronRight, Bell } from 'lucide-react';

// const ImageAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   const images = [
//     { 
//       src: '/assets/fitfloppush.png', 
//       alt: 'push Ad',
//     },
//   ];

//   const handleExpand = (e) => {
//     if (e) {
//       e.stopPropagation();
//     }
//     if (onExpand && !isInPreview) {
//       onExpand();
//     }
//   };

//   return (
//     <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
//       {!isExpanded ? (
//         <div className="relative h-full">
//           {/* Compact Image Ad */}
//           <div 
//             className={`relative cursor-pointer transform transition-all duration-300 ${
//               !isInPreview ? 'hover:scale-105' : ''
//             } w-full h-full`}
//           >
//             {/* Image Container */}
//             <div className="relative w-full h-full overflow-hidden">
//               <img
//                 src={images[currentImageIndex].src}
//                 alt={images[currentImageIndex].alt}
//                 className="w-full h-full object-cover transition-opacity duration-300"
//               />

//               {/* Ad Label */}
//               <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
//                 AD
//               </div>
//             </div>
//           </div>
//         </div>
//       ) : (
//         /* Expanded Image Experience - Full Screen */
//         <div className="w-full h-full flex items-center justify-center relative">
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               onClose();
//             }}
//             className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
//           >
//             ×
//           </button>
          
        //   <div className="relative w-full h-full max-w-4xl flex items-center justify-center">
        //     <img
        //       src={images[currentImageIndex].src}
        //       alt={images[currentImageIndex].alt}
        //       className="max-w-full max-h-full object-contain cursor-pointer"
        //     />

//             {/* Image dots indicator */}
//             <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
//               {images.map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setCurrentImageIndex(index);
//                   }}
//                   className={`w-3 h-3 rounded-full transition-all duration-200 ${
//                     index === currentImageIndex ? 'bg-white' : 'bg-white/50 hover:bg-white/70'
//                   }`}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // Push Notification Component
// const PushNotificationMockup = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [isGlowing, setIsGlowing] = useState(false);
//   const [hasSlideIn, setHasSlideIn] = useState(false);
  
//   useEffect(() => {
//     // Stage 1: Slide in from right
//     const slideTimer = setTimeout(() => setHasSlideIn(true), 500);
    
//     // Stage 2: Show notification
//     const showTimer = setTimeout(() => setIsVisible(true), 1000);
    
//     // Stage 3: Add glow effect
//     const glowTimer = setTimeout(() => setIsGlowing(true), 1500);
    
//     // Stage 4: Remove glow
//     const removeGlowTimer = setTimeout(() => setIsGlowing(false), 3000);
    
//     return () => {
//       clearTimeout(slideTimer);
//       clearTimeout(showTimer);
//       clearTimeout(glowTimer);
//       clearTimeout(removeGlowTimer);
//     };
//   }, []);

//   return (
//     <div className={`absolute -right-4 top-8 w-80 z-10 transform transition-all duration-700 ${
//       hasSlideIn ? 'translate-x-0' : 'translate-x-full'
//     } ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
//       {/* Push Notification Banner */}
//       <div className={`bg-white rounded-xl shadow-2xl border border-gray-200 p-4 transition-all duration-500 ${
//         isGlowing ? 'ring-4 ring-blue-300 ring-opacity-50 shadow-blue-200' : ''
//       } animate-bounce-gentle`}>
//         <div className="flex items-start space-x-3">
//           {/* App Icon */}
//           <div className="flex-shrink-0">
//             <div className={`w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center transition-all duration-300 ${
//               isGlowing ? 'animate-pulse' : ''
//             }`}>
//               <Bell className="w-4 h-4 text-white animate-wiggle" />
//             </div>
//           </div>
          
//           {/* Notification Content */}
//           <div className="flex-1 min-w-0">
//             <div className="flex items-center justify-between mb-1">
//               <p className="text-sm font-semibold text-gray-900 animate-fade-in-up" style={{animationDelay: '1.2s'}}>FitFlop</p>
//               <p className="text-xs text-gray-500 animate-fade-in-up" style={{animationDelay: '1.4s'}}>now</p>
//             </div>
//             <p className="text-sm text-gray-800 font-medium mb-1 animate-fade-in-up" style={{animationDelay: '1.6s'}}>Step Into Action! 50% OFF</p>
//             <p className="text-xs text-gray-600 animate-fade-in-up" style={{animationDelay: '1.8s'}}>Don't miss out on our biggest sale of the year. Limited time offer!</p>
//           </div>
          
//           {/* Notification Actions */}
//           <div className="flex-shrink-0 animate-fade-in-up" style={{animationDelay: '2s'}}>
//             <button className="text-gray-400 hover:text-gray-600 transition-colors duration-200 hover:rotate-90 transform">
//               <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
//               </svg>
//             </button>
//           </div>
//         </div>
        
//         {/* Notification indicator dot */}
//         <div className="absolute -top-1 -left-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></div>
//         <div className="absolute -top-1 -left-1 w-3 h-3 bg-red-500 rounded-full"></div>
//       </div>
//     </div>
//   );
// };

// function TelegramPush() {
//   const [isExpanded, setIsExpanded] = useState(false);

//   return (
//     <>
//       <div className="min-h-screen bg-gray-50 mt-10">
//         <div className="container mx-auto px-4 py-8 lg:py-12">
//           <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
//             {/* Left column - Content */}
//             <div className="flex-1 lg:max-w-lg">
//               {/* Header */}
//               <header className="animate-slide-up">
//                 {/* Title and tag */}
//                 <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
//                   <div className="flex flex-wrap items-center gap-3 mb-3">
//                     <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
//                       Step Into Action
//                     </h1>
//                     <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
//                       Fitflop
//                     </span>
//                   </div>
//                 </div>
//               </header>

//               {/* Content Section */}
//               <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
//                 {/* Make it yours section */}
//                 <div className="mb-8">
//                   <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
//                     REACH THEM IN REAL TIME
//                   </h2>
//                   <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
//                     Push Notifications put Fitflop at your audience's fingertips—alerting them to fresh collections, limited-time offers, or back-in-stock favorites the moment they happen. Your message pops up instantly, inspiring quick clicks and faster conversions. It's timely, targeted, and designed to get feet moving.
//                   </p>
                  
//                   {/* CTA Button */}
//                   <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
//                     <span>Start with this Template</span>
//                     <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Right column - Mobile Mockup Only */}
//             <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
//               <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
//                 {/* Mobile Mockup with Push Notification */}
//                 <div className="mx-auto max-w-xs relative">
//                   {/* Push Notification positioned to the right */}
//                   <PushNotificationMockup />
                  
//                   {/* iPhone mockup with enhanced animations */}
//                   <div className="relative rounded-[2.5rem] p-2 shadow-2xl bg-black animate-phone-appear">
//                     {/* Status bar area */}
//                     <div className="bg-white rounded-[2rem] overflow-hidden">
//                       {/* Status bar */}
//                       <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium animate-fade-in-down" style={{animationDelay: '0.6s'}}>
//                         <span className="animate-pulse-slow">9:41</span>
//                         <div className="flex items-center space-x-1">
//                           <div className="flex space-x-1">
//                             <div className="w-1 h-1 bg-black rounded-full animate-signal-bar" style={{animationDelay: '0.8s'}}></div>
//                             <div className="w-1 h-1 bg-black rounded-full animate-signal-bar" style={{animationDelay: '0.9s'}}></div>
//                             <div className="w-1 h-1 bg-black rounded-full animate-signal-bar" style={{animationDelay: '1.0s'}}></div>
//                             <div className="w-1 h-1 bg-black rounded-full animate-signal-bar" style={{animationDelay: '1.1s'}}></div>
//                           </div>
//                           <div className="w-6 h-3 border border-black rounded-sm relative">
//                             <div className="w-4/5 h-full bg-green-500 rounded-sm animate-battery-fill"></div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Browser bar */}
//                       <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3 animate-fade-in-down" style={{animationDelay: '0.8s'}}>
//                         <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center animate-type-text">
//                           publisher.com
//                         </div>
//                       </div>

//                       {/* Content area - Non-scrollable */}
//                       <div className="p-4 bg-gray-50 h-[400px] overflow-hidden">
//                         <div className="space-y-3 animate-content-load" style={{animationDelay: '1.0s'}}>
//                           <div className="h-3 bg-gray-200 rounded w-full animate-skeleton-shimmer"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full animate-skeleton-shimmer" style={{animationDelay: '0.1s'}}></div>
//                           <div className="h-3 bg-gray-200 rounded w-full animate-skeleton-shimmer" style={{animationDelay: '0.2s'}}></div>
//                         </div>
                        
//                         {/* Image Ad - Full width on mobile with enhanced animation */}
//                         <div className="mb-6 mt-6 animate-ad-slide-up" style={{animationDelay: '1.5s'}}>
//                           <div className="h-64 rounded-lg overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-xl">
//                             <ImageAdContent 
//                               isInPreview={true}
//                               isExpanded={isExpanded}
//                               onExpand={() => setIsExpanded(true)}
//                               onClose={() => setIsExpanded(false)}
//                             />
//                           </div>
//                         </div>
                        
//                         <div className="space-y-3 animate-content-load" style={{animationDelay: '2.0s'}}>
//                           <div className="h-3 bg-gray-200 rounded w-full animate-skeleton-shimmer"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6 animate-skeleton-shimmer" style={{animationDelay: '0.1s'}}></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6 animate-skeleton-shimmer" style={{animationDelay: '0.2s'}}></div>
//                         </div>
//                         <div className="space-y-3 mt-2 animate-content-load" style={{animationDelay: '2.2s'}}>
//                           <div className="h-3 bg-gray-200 rounded w-full animate-skeleton-shimmer"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6 animate-skeleton-shimmer" style={{animationDelay: '0.1s'}}></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6 animate-skeleton-shimmer" style={{animationDelay: '0.2s'}}></div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Expanded Image Overlay */}
//         {isExpanded && (
//           <div className="fixed inset-0 z-50">
//             <ImageAdContent 
//               isExpanded={true}
//               onClose={() => setIsExpanded(false)}
//             />
//           </div>
//         )}

//         <style jsx>{`
//           @keyframes slide-up {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
          
//           @keyframes fade-in {
//             from { opacity: 0; }
//             to { opacity: 1; }
//           }

//           @keyframes fade-in-up {
//             from {
//               opacity: 0;
//               transform: translateY(10px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }

//           @keyframes fade-in-down {
//             from {
//               opacity: 0;
//               transform: translateY(-10px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }

//           @keyframes phone-appear {
//             from {
//               opacity: 0;
//               transform: translateY(30px) scale(0.95);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0) scale(1);
//             }
//           }

//           @keyframes wiggle {
//             0%, 7% { transform: rotateZ(0); }
//             15% { transform: rotateZ(-15deg); }
//             20% { transform: rotateZ(10deg); }
//             25% { transform: rotateZ(-10deg); }
//             30% { transform: rotateZ(6deg); }
//             35% { transform: rotateZ(-4deg); }
//             40%, 100% { transform: rotateZ(0); }
//           }

//           @keyframes bounce-gentle {
//             0%, 100% { transform: translateY(0); }
//             50% { transform: translateY(-5px); }
//           }

//           @keyframes pulse-slow {
//             0%, 100% { opacity: 1; }
//             50% { opacity: 0.5; }
//           }

//           @keyframes signal-bar {
//             from {
//               opacity: 0;
//               transform: scaleY(0);
//             }
//             to {
//               opacity: 1;
//               transform: scaleY(1);
//             }
//           }

//           @keyframes battery-fill {
//             from {
//               width: 0;
//             }
//             to {
//               width: 80%;
//             }
//           }

//           @keyframes type-text {
//             from {
//               width: 0;
//             }
//             to {
//               width: 100%;
//             }
//           }

//           @keyframes skeleton-shimmer {
//             0% {
//               background-position: -200px 0;
//             }
//             100% {
//               background-position: calc(200px + 100%) 0;
//             }
//           }

//           @keyframes content-load {
//             from {
//               opacity: 0;
//               transform: translateY(10px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }

//           @keyframes ad-slide-up {
//             from {
//               opacity: 0;
//               transform: translateY(20px) scale(0.98);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0) scale(1);
//             }
//           }
          
//           .animate-slide-up {
//             animation: slide-up 0.6s ease-out forwards;
//           }
          
//           .animate-fade-in {
//             animation: fade-in 0.6s ease-out forwards;
//           }

//           .animate-fade-in-up {
//             animation: fade-in-up 0.4s ease-out forwards;
//             opacity: 0;
//             animation-fill-mode: both;
//           }

//           .animate-fade-in-down {
//             animation: fade-in-down 0.4s ease-out forwards;
//             opacity: 0;
//             animation-fill-mode: both;
//           }

//           .animate-phone-appear {
//             animation: phone-appear 0.8s ease-out forwards;
//           }

//           .animate-wiggle {
//             animation: wiggle 2s ease-in-out infinite;
//           }

//           .animate-bounce-gentle {
//             animation: bounce-gentle 2s ease-in-out infinite;
//           }

//           .animate-pulse-slow {
//             animation: pulse-slow 2s ease-in-out infinite;
//           }

//           .animate-signal-bar {
//             animation: signal-bar 0.3s ease-out forwards;
//             opacity: 0;
//             animation-fill-mode: both;
//           }

//           .animate-battery-fill {
//             animation: battery-fill 1s ease-out forwards;
//             animation-delay: 1.2s;
//           }

//           .animate-type-text {
//             overflow: hidden;
//             white-space: nowrap;
//             animation: type-text 1s ease-out forwards;
//             animation-delay: 1s;
//           }

//           .animate-skeleton-shimmer {
//             background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//             background-size: 200px 100%;
//             animation: skeleton-shimmer 1.5s infinite;
//           }

//           .animate-content-load {
//             animation: content-load 0.5s ease-out forwards;
//             opacity: 0;
//             animation-fill-mode: both;
//           }

//           .animate-ad-slide-up {
//             animation: ad-slide-up 0.6s ease-out forwards;
//             opacity: 0;
//             animation-fill-mode: both;
//           }
          
//           .hide-scrollbar {
//             -ms-overflow-style: none;
//             scrollbar-width: none;
//           }
          
//           .hide-scrollbar::-webkit-scrollbar {
//             display: none;
//           }
//         `}</style>
//       </div>
      
//       <div className="max-w-7xl mx-auto px-4 py-10">
//         <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
  
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//           {/* Card 1 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/ps.avif"
//               alt="Card 1"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">PS5</h2>
//             </div>
//           </div>

//           {/* Card 2 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/moll.avif"
//               alt="Card 2"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Mollers</h2>
//             </div>
//           </div>

//           {/* Card 3 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/tiger.avif"
//               alt="Card 3"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Tiger</h2>
//             </div>
//           </div>

//           {/* Card 4 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/ab.avif"
//               alt="Card 4"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">ABC Beer</h2>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default TelegramPush;

// import React, { useState, useEffect } from 'react';
// import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe, ChevronLeft, ChevronRight, Bell } from 'lucide-react';

// const ImageAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   const images = [
//     { 
//       src: '/assets/fitfloppush.png', 
//       alt: 'push Ad',
//     },
//   ];

//   const handleExpand = (e) => {
//     if (e) {
//       e.stopPropagation();
//     }
//     if (onExpand && !isInPreview) {
//       onExpand();
//     }
//   };

//   return (
//     <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
//       {!isExpanded ? (
//         <div className="relative h-full">
//           {/* Compact Image Ad */}
//           <div 
//             className={`relative cursor-pointer transform transition-all duration-300 ${
//               !isInPreview ? 'hover:scale-105' : ''
//             } w-full h-full`}
//           >
//             {/* Image Container */}
//             <div className="relative w-full h-full overflow-hidden">
//               <img
//                 src={images[currentImageIndex].src}
//                 alt={images[currentImageIndex].alt}
//                 className="w-full h-full object-cover transition-opacity duration-300"
//               />

//               {/* Ad Label */}
//               <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
//                 AD
//               </div>
//             </div>
//           </div>
//         </div>
//       ) : (
//         /* Expanded Image Experience - Full Screen */
//         <div className="w-full h-full flex items-center justify-center relative">
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               onClose();
//             }}
//             className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
//           >
//             ×
//           </button>
          
//           <div className="relative w-full h-full max-w-4xl flex items-center justify-center">
//             <img
//               src={images[currentImageIndex].src}
//               alt={images[currentImageIndex].alt}
//               className="max-w-full max-h-full object-contain cursor-pointer"
//             />

//             {/* Image dots indicator */}
//             <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
//               {images.map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setCurrentImageIndex(index);
//                   }}
//                   className={`w-3 h-3 rounded-full transition-all duration-200 ${
//                     index === currentImageIndex ? 'bg-white' : 'bg-white/50 hover:bg-white/70'
//                   }`}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // Push Notification Component
// const PushNotificationMockup = () => {
//   const [isVisible, setIsVisible] = useState(false);
  
//   useEffect(() => {
//     // Animate notification appearance
//     const timer = setTimeout(() => setIsVisible(true), 1000);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <div className={`transform transition-all duration-500 ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0'}`}>
//       {/* Push Notification Banner */}
//       <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-4 mb-4 mx-4">
//         <div className="flex items-start space-x-3">
//           {/* App Icon */}
//           <div className="flex-shrink-0">
//             <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
//               <Bell className="w-4 h-4 text-white" />
//             </div>
//           </div>
          
//           {/* Notification Content */}
//           <div className="flex-1 min-w-0">
//             <div className="flex items-center justify-between mb-1">
//               <p className="text-sm font-semibold text-gray-900">FitFlop</p>
//               <p className="text-xs text-gray-500">now</p>
//             </div>
//             <p className="text-sm text-gray-800 font-medium mb-1">Step Into Action! 50% OFF</p>
//             <p className="text-xs text-gray-600">Don't miss out on our biggest sale of the year. Limited time offer!</p>
//           </div>
          
//           {/* Notification Actions */}
//           <div className="flex-shrink-0">
//             <button className="text-gray-400 hover:text-gray-600">
//               <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// function TelegramPush() {
//   const [isExpanded, setIsExpanded] = useState(false);

//   return (
//     <>
//       <div className="min-h-screen bg-gray-50 mt-10">
//         <div className="container mx-auto px-4 py-8 lg:py-12">
//           <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
//             {/* Left column - Content */}
//             <div className="flex-1 lg:max-w-lg">
//               {/* Header */}
//               <header className="animate-slide-up">
//                 {/* Title and tag */}
//                 <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
//                   <div className="flex flex-wrap items-center gap-3 mb-3">
//                     <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
//                       Step Into Action
//                     </h1>
//                     <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
//                       Fitflop
//                     </span>
//                   </div>
//                 </div>
//               </header>

//               {/* Content Section */}
//               <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
//                 {/* Make it yours section */}
//                 <div className="mb-8">
//                   <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
//                     REACH THEM IN REAL TIME
//                   </h2>
//                   <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
//                     Push Notifications put Fitflop at your audience's fingertips—alerting them to fresh collections, limited-time offers, or back-in-stock favorites the moment they happen. Your message pops up instantly, inspiring quick clicks and faster conversions. It's timely, targeted, and designed to get feet moving.
//                   </p>
                  
//                   {/* CTA Button */}
//                   <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
//                     <span>Start with this Template</span>
//                     <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Right column - Mobile Mockup Only */}
//             <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
//               <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
//                 {/* Mobile Mockup with Push Notification */}
//                 <div className="mx-auto max-w-xs">
//                   {/* Push Notification at the top */}
//                   <PushNotificationMockup />
                  
//                   {/* iPhone mockup */}
//                   <div className="relative rounded-[2.5rem] p-2 shadow-2xl bg-black">
//                     {/* Status bar area */}
//                     <div className="bg-white rounded-[2rem] overflow-hidden">
//                       {/* Status bar */}
//                       <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
//                         <span>9:41</span>
//                         <div className="flex items-center space-x-1">
//                           <div className="flex space-x-1">
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                           </div>
//                           <div className="w-6 h-3 border border-black rounded-sm relative">
//                             <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Browser bar */}
//                       <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
//                         <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
//                           publisher.com
//                         </div>
//                       </div>

//                       {/* Content area */}
//                       <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                        
                        
//                         {/* Image Ad - Full width on mobile with same gap from top */}
//                         <div className="mb-6 mt-6">
//                           <div className="h-64 rounded-lg overflow-hidden">
//                             <ImageAdContent 
//                               isInPreview={true}
//                               isExpanded={isExpanded}
//                               onExpand={() => setIsExpanded(true)}
//                               onClose={() => setIsExpanded(false)}
//                             />
//                           </div>
//                         </div>
                        
                      
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Expanded Image Overlay */}
//         {isExpanded && (
//           <div className="fixed inset-0 z-50">
//             <ImageAdContent 
//               isExpanded={true}
//               onClose={() => setIsExpanded(false)}
//             />
//           </div>
//         )}

//         <style jsx>{`
//           @keyframes slide-up {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
          
//           @keyframes fade-in {
//             from { opacity: 0; }
//             to { opacity: 1; }
//           }
          
//           .animate-slide-up {
//             animation: slide-up 0.6s ease-out forwards;
//           }
          
//           .animate-fade-in {
//             animation: fade-in 0.6s ease-out forwards;
//           }
          
//           .hide-scrollbar {
//             -ms-overflow-style: none;
//             scrollbar-width: none;
//           }
          
//           .hide-scrollbar::-webkit-scrollbar {
//             display: none;
//           }
//         `}</style>
//       </div>
      
//       <div className="max-w-7xl mx-auto px-4 py-10">
//         <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
  
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//           {/* Card 1 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/ps.avif"
//               alt="Card 1"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">PS5</h2>
//             </div>
//           </div>

//           {/* Card 2 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/moll.avif"
//               alt="Card 2"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Mollers</h2>
//             </div>
//           </div>

//           {/* Card 3 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/tiger.avif"
//               alt="Card 3"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Tiger</h2>
//             </div>
//           </div>

//           {/* Card 4 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/ab.avif"
//               alt="Card 4"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">ABC Beer</h2>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default TelegramPush;